jQuery(function(){

  $('.press-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   asNavFor: '.slider-nav',
   autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'ease-in',
    fade: true
  });
  $('.slider-nav').slick({
   slidesToShow: 5,
   slidesToScroll: 1,
   asNavFor: '.press-slider',
   dots: false,
   arrows: false,
   centerMode: false,
   focusOnSelect: true,
   infinite: false,
   variableWidth: true,
   responsive: [
     {
       breakpoint: 800,
       settings: {
         slidesToShow: 5,
         slidesToScroll: 3,
         infinite: true,
         dots: true
       }
     },
     {
       breakpoint: 479,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1,
         infinite: true,
         dots: true
       }
     },
   ]
  });
  // $('.press-slider').find('.slick-arrow').text(' ');

  $('.press-slider').on( 'afterChange', function(){
     $('.slider-nav').find('.press-item').removeClass('active');
     var a = false;
     $('.slider-nav').find('.press-item').each(function(k,v){
         if(!a){
           $(this).addClass('active');
         }
       if( $(this).hasClass('slick-current') ){
         a = true;
       }
     });
   });
});